export enum SubscriptionType {
    GET_SUBSCRIPTIONS = 'GET_ALL_SUBSCRIPTIONS',
    GET_SUBSCRIPTIONS_SUCCESS = 'GET_ALL_SUBSCRIPTIONS_SUCCESS',
    GET_SUBSCRIPTIONS_FAILURE = 'GET_ALL_SUBSCRIPTIONS_FAILURE',

    GET_SINGLE_SUBSCRIPTION = 'GET_SINGLE_SUBSCRIPTION',
    GET_SINGLE_SUBSCRIPTION_SUCCESS = 'GET_SINGLE_SUBSCRIPTION_SUCCESS',
    GET_SINGLE_SUBSCRIPTION_FAILURE = 'GET_SINGLE_SUBSCRIPTION_FAILURE',

    CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE',
    CANCEL_SUBSCRIPTION_SUCCESS = 'CANCE_SUBSCRIPTION_SUCCESS',

    CLEAR_CANCEL_SUBSCRIPTION_STATE = 'CLEAR_CANCEL_SUBSCRIPTION_STATE',
}
